import { MantineSize, rem } from "@mantine/core"

export const getIconSize = (size: string | undefined) => {
  switch (size) {
    case "xs":
      return 10
    case "sm":
      return 14
    case "md":
      return 18
    case "lg":
      return 22
    default:
      return 14
  }
}

export function getIconButtonSize(
  size:
    | MantineSize
    | "compact-xs"
    | "compact-sm"
    | "compact-md"
    | "compact-lg"
    | "compact-xl"
    | (string & NonNullable<unknown>)
) {
  const sizeMap: Record<typeof size, number> = {
    xs: 14,
    "compact-xs": 14,
    sm: 16,
    "compact-sm": 16,
    md: 20,
    "compact-md": 20,
    lg: 24,
    "compact-lg": 24,
    xl: 28,
    "compact-xl": 28,
  }

  return {
    width: rem(sizeMap[size]),
    height: rem(sizeMap[size]),
  }
}
